import { render } from "./EditTax.vue?vue&type=template&id=6bcdd974&ts=true"
import script from "./EditTax.vue?vue&type=script&lang=ts"
export * from "./EditTax.vue?vue&type=script&lang=ts"

import exportComponent from "/home/uat/uatdan_yrshop_admin/public_html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__